export enum ConfirmStatus {
    NOT_CONFIRMED = 1,
    CONFIRMED = 2,
    NOT_APPLICABLE = 3,
    PURCHASE_CLOSED = 4
}
